
export default {
  lookup: {
    column_createdon: 'Creation time',
    column_name: 'name'
  },
  xpc: {
    address: {
      city: 'city',
      county: 'county',
      noSelected: 'Not selected',
      province: 'province',
      parse: 'Parse',
      error: 'Recognition failed',
      success: 'Recognition success'
    },
    addressCascader: {
      city: 'city',
      country: 'country',
      province: 'province'
    },
    advancetable: {
      checkall: 'Select all'
    },
    attachment: {
      novalue: 'There are no attachments for the time being',
      successmsg: 'Attachment uploaded successfully!',
      title: 'Attachment'
    },
    business: {
      attr: {
        detail: 'details'
      },
      detailaside: {
        more: 'Expand more',
        up: 'Collapse all'
      }
    },
    common: {
      add: 'add',
      cancel: 'cancel',
      collapse: 'collapse',
      comfirmDelete: 'Are you sure you want to delete this item?',
      comfirmLogout: 'Confirm logout?',
      confirmDeleteAll: 'Are you sure you want to delete all?',
      delete: 'delete',
      edit: 'edit',
      hasEnter: 'The word {count} has been entered',
      hint: 'hint',
      loadError: 'Loading failed',
      look: 'look',
      main: 'main',
      messageNotification: 'Message notification',
      more: 'more',
      next: 'next',
      noSelected: 'Not selected',
      ok: 'ok',
      operation: 'operation',
      pleaseSearch: 'Please search',
      pleaseSelect: 'Please select',
      prev: 'Previous',
      reset: 'reset',
      saving: 'saving',
      seemore: 'See more',
      selected: 'Selected',
      showAll: 'View all',
      totalRecords: 'Total {count} records',
      record: 'records',
      notFound: 'Not Found {label}'
    },
    datepicker: {
      endDateCannotEarlierStartDate:
        'The end date cannot be earlier than the start date!',
      pleaseSelectStartDate: 'Please select the start date first!',
      to: 'to'
    },
    defaultImage: {
      noData: 'No Data'
    },
    detailheader: {
      back: 'back'
    },
    comment: {
      reply: 'reply',
      comment: 'comment ',
      report: 'report',
      expression: 'expression',
      publish: 'publish',
      author: 'author',
      entercommentshere: 'Enter comments here',
      smile: 'smile',
      heehee: 'heehee',
      haha: 'haha',
      lovely: 'lovely',
      poor: 'poor',
      nosedigging: 'Nose digging',
      beamazed: 'be amazed',
      shyness: 'shyness',
      blinkeyes: 'blink the eyes',
      despise: 'despise',
      loveyou: 'love you',
      tear: 'tear',
      snicker: 'snicker',
      kiss: 'kiss',
      fallill: 'fall ill',
      toohappy: 'Too happy',
      superciliouslook: 'supercilious look',
      righthem: 'Right hem',
      lefthem: 'Left hem',
      shh: 'Shh',
      decline: 'decline ',
      spit: 'spit',
      yawn: 'Yawn',
      cuddle: 'Cuddle',
      anger: 'anger',
      doubt: 'doubt',
      greedy: 'greedy',
      byebye: 'bye-bye',
      reflection: 'reflection',
      sweat: 'sweat',
      sleepy: 'sleepy',
      sleep: 'sleep',
      money: 'money',
      disappointment: 'disappointment',
      cool: 'Cool',
      colour: 'colour',
      hum: 'Hum',
      applause: 'applause',
      halo: 'halo',
      sadness: 'Sadness',
      madness: 'Madness',
      blackline: 'Black line',
      insidious: 'Insidious',
      fulminate: 'Fulminate',
      becomeother: 'become a fan for each other',
      bookworm: 'bookworm',
      cold: 'cold',
      heart: 'heart',
      sad: 'Sad',
      pig: 'pig',
      panda: 'panda',
      rabbit: 'rabbit',
      wok: 'Wok',
      yeah: 'yeah',
      bangbang: 'Bang Bang',
      no: 'no',
      fabulous: 'fabulous',
      come: 'come',
      weak: 'weak',
      grassmudhorse: 'Grass Mud Horse',
      divinehorse: 'Divine horse',
      embarrassed: 'embarrassed',
      floatingclouds: 'floating clouds',
      awesome: 'Awesome',
      gatherandwatch: 'gather and watch',
      mighty: 'Mighty',
      microphone: 'Microphone',
      candle: 'candle',
      cake: 'Cake',
      redenvelopes: 'Hand out red envelopes'
    },
    dialog: {
      cancel: 'cancel',
      confirm: 'confirm',
      oneClickClear: 'One click clear',
      exitFullScreen: 'Exit full screen',
      fullScreen: 'Full screen',
      exitBrowserFullScreen: 'Exit Browser Full Screen',
      browserFullScreen: 'Browser Full Screen',
      collapse: 'Collapse',
      expandDown: 'Expand Down',
      expandLeft: 'Expand Left',
      expandUp: 'Expand Up',
      expandRight: 'Expand Right'
    },
    form: {
      notFilled: 'Not filled in',
      pleaseEnter: 'Please enter',
      addFormItem: 'Add form item'
    },
    lookup: {
      placeholder: 'Please select',
      selectedItems: '{count} item selected',
      searchItems: '{count} item selected, {search} item searched',
      showSelected: 'Show only selected'
    },
    search: {
      more: 'More filtering',
      search: 'search',
      pleaseSearch: 'Please search...'
    },
    section: {
      more: 'more'
    },
    uploadfile: {
      confirmdelete: 'Are you sure you want to delete this item?',
      delete: 'delete',
      download: 'download',
      edit: 'edit',
      filelist: 'File list',
      filename: 'File name',
      filenameplaceholder: 'Please fill in the name of the file',
      filesize: 'File size',
      nodata: 'No data',
      operate: 'operation',
      pleaseAddCorrectVideoFormat: 'Please upload the correct video format',
      pleaseAddFileHint: 'Please add the files to upload here',
      reUpload: 'Re upload',
      remark: 'remark',
      remarkplaceholder: 'Please fill in the remarks',
      save: 'save',
      size: 'size',
      title: 'title',
      titleplaceholder: 'Please fill in the title',
      updownError: 'Upload failed',
      upload: 'Click upload',
      uploadError: 'Upload error',
      uploadPercent: 'Uploaded {count}%',
      uploadSuccess: 'Upload successful',
      uploaded: 'Uploaded {count}',
      uploadfile: 'Upload file',
      uploading: 'Uploading',
      videoSizeCannotExceed5000: 'Video size cannot exceed 5000MB',
      notAdded: 'Not Added'
    },
    richEditor: {
      placeholder: 'Please enter the content',
      undo: 'Undo',
      redo: 'Redo',
      h1: 'Header 1',
      h2: 'Header 2',
      h3: 'Header 3',
      h4: 'Header 4',
      text: 'Text',
      italic: 'Italic',
      underline: 'Underline',
      strike: 'Strike',
      sub: 'Sub',
      super: 'Super',
      clean: 'Clean',
      ordered: 'Ordered',
      bullet: 'Bullet',
      indent0: 'Decrease indent',
      indent1: 'Add indent',
      blockquote: 'Blockquote',
      link: 'Link',
      image: 'Image',
      video: 'Video',
      divider: 'Divider'
    },
    guide: {
      startExpericencing: 'Start experiencing'
    },
    table: {
      selectedItemsPrev: '',
      selectedItemsNext: ' item(s) selected',
      deleteAllSelected: 'Remove all selected items?',
      confirmationPrompt: 'Confirmation prompt'
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/locale/lang/en-US.js